/********************************************************************************
 * Copyright (c) 2021 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PremiumVersionIcon from '@mui/icons-material/esm/VerifiedUser';

export const isPremiumLicense = (license) => license && license.edition === 'pro';

export const getPremium = () => {
	return (
		<span>
			<PremiumVersionIcon fontSize="small" style={{ color: '#ffc107', verticalAlign: 'middle' }} /> Premium
		</span>
	);
};

export const getLicenseValidUntil = (daysLeft) => {
	const date = new Date();
	date.setDate(date.getDate() + daysLeft);
	return date.toLocaleDateString();
};

export const getLicenseInstallationsInfo = ({ maxInstallations = -1 }) => {
	if (maxInstallations < 0) {
		return <FormattedMessage id="License.Unlimited" defaultMessage="Unlimited" />;
	}
	return maxInstallations;
};

export const getLicenseStreamsheetsInfo = ({ maxStreamsheets = -1, usedStreamsheets = 0 }) => {
	if (maxStreamsheets < 0) {
		return <FormattedMessage id="License.Unlimited" defaultMessage="Unlimited" />;
	}
	const remaining = Math.max(0, maxStreamsheets - usedStreamsheets);
	return (
		<FormattedMessage
			id="License.StreamsheetsInfo"
			defaultMessage="{maxStreamsheets} ({remaining} remain)"
			values={{ maxStreamsheets, remaining }}
		/>
	);
};
